import { render, staticRenderFns } from "./AORecruitingDashboard.vue?vue&type=template&id=03774748&"
import script from "./AORecruitingDashboard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AORecruitingDashboard.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports